/*
 * EM Devis page — affichage des items en localStorage + form contact
 */
(function () {
  const KEY = 'em_quote_products';
  const section = document.querySelector('.em-devis');
  if (!section) return;

  const countEl = section.querySelector('[data-em-devis-count]');
  const clearBtn = section.querySelector('[data-em-devis-clear]');
  const saveWlBtn = section.querySelector('[data-em-devis-save-wl]');
  const empty = section.querySelector('[data-em-devis-empty]');
  const itemsWrap = section.querySelector('[data-em-devis-items]');
  const totalWrap = section.querySelector('[data-em-devis-total]');
  const totalVal = section.querySelector('[data-em-devis-total-value]');
  const formCol = section.querySelector('[data-em-devis-form-col]');
  const form = section.querySelector('[data-em-devis-form]');
  const tpl = document.getElementById('em-devis-item-tpl');

  const formatEur = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(cents / 100);

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
  }
  function save(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function render() {
    const list = load();
    countEl.textContent = `(${list.length})`;
    clearBtn.hidden = list.length === 0;
    if (saveWlBtn) saveWlBtn.hidden = list.length === 0;
    empty.hidden = list.length > 0;
    itemsWrap.hidden = list.length === 0;
    totalWrap.hidden = list.length === 0;
    formCol.hidden = list.length === 0;

    // Capture l'état actuel : volets ouverts/fermés + position scroll
    const openState = new Map();
    itemsWrap.querySelectorAll('details[data-type]').forEach(d => {
      openState.set(d.dataset.type, d.open);
    });
    const scrollY = window.scrollY;

    itemsWrap.innerHTML = '';
    let total = 0;

    // Groupement par type (catégorie) avec préservation de l'ordre d'apparition
    const groups = new Map();
    list.forEach((item, idx) => {
      const key = (item.type || 'Autres').trim() || 'Autres';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push({ item, idx });
    });

    groups.forEach((entries, type) => {
      // Stats du groupe
      let gCount = 0, gQty = 0, gSub = 0;
      entries.forEach(({ item }) => {
        const unit = parseInt(item.unit_price || 0, 10);
        const qty = Math.max(1, parseInt(item.qty || 1, 10));
        gCount++;
        gQty += qty;
        gSub += unit * qty;
      });
      total += gSub;

      // Container <details>
      const det = document.createElement('details');
      det.className = 'em-devis__group';
      // Restaure l'état précédent (open par défaut si nouveau groupe)
      det.open = openState.has(type) ? openState.get(type) : true;
      det.dataset.type = type;

      const sum = document.createElement('summary');
      sum.className = 'em-devis__group-head';
      sum.innerHTML = `
        <span class="em-devis__group-chev" aria-hidden="true">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
        </span>
        <span class="em-devis__group-title">${escapeHtml(type)}</span>
        <span class="em-devis__group-meta">
          ${gCount} ${gCount > 1 ? 'produits' : 'produit'} · ${gQty} ${gQty > 1 ? 'articles' : 'article'} · <strong>${formatEur(gSub)}</strong>
        </span>
      `;
      det.appendChild(sum);

      const inner = document.createElement('div');
      inner.className = 'em-devis__group-items';
      entries.forEach(({ item, idx }) => {
        const node = tpl.content.cloneNode(true);
        const url = item.handle ? `/products/${item.handle}` : '#';
        node.querySelectorAll('[data-em-link]').forEach(a => a.href = url);
        node.querySelector('[data-em-img]').src = item.image || '';
        node.querySelector('[data-em-img]').alt = item.title || '';
        node.querySelector('[data-em-title]').textContent = item.title || '';
        node.querySelector('[data-em-type]').textContent = item.type || '';
        const unit = parseInt(item.unit_price || 0, 10);
        node.querySelector('[data-em-unit]').textContent = formatEur(unit);
        const qty = Math.max(1, parseInt(item.qty || 1, 10));
        node.querySelector('[data-em-qty]').value = qty;
        const line = unit * qty;
        node.querySelector('[data-em-line]').textContent = formatEur(line);
        const row = node.querySelector('[data-em-devis-item]');
        row.dataset.idx = idx;
        inner.appendChild(node);
      });
      det.appendChild(inner);
      itemsWrap.appendChild(det);
    });

    totalVal.textContent = formatEur(total);
    syncPaliers(total);

    // Restaure la position scroll
    window.scrollTo(0, scrollY);
  }
  // Livraison par paliers, comme le paiement en ligne (2026-10-16) :
  // bas d'immeuble 39 € jusqu'à 100 €, 59 € jusqu'à 300 €, 79 € jusqu'à
  // 500 €, 99 € au-delà ; en étage (169 €) seulement à partir de 500 €.
  function syncPaliers(totalCents) {
    if (!form) return;
    const bas = form.querySelector('input[name="shipping"][value="bas_immeuble"]');
    const piece = form.querySelector('input[name="shipping"][value="piece"]');
    if (!bas || !piece) return;
    const etage = totalCents >= 50000;
    const prixBas = totalCents < 10000 ? 3900 : totalCents < 30000 ? 5900 : totalCents < 50000 ? 7900 : 9900;
    const regler = (input, visible, prix) => {
      const label = input.closest('label');
      if (label) label.hidden = !visible;
      input.disabled = !visible;
      if (!visible && input.checked) { input.checked = false; input.dispatchEvent(new Event('change', { bubbles: true })); }
      const p = label && label.querySelector('.em-devis__ship-price');
      if (p && prix != null) p.textContent = formatEur(prix);
    };
    regler(bas, true, prixBas);
    regler(piece, etage, 16900);
    const note = form.querySelector('[data-em-ship-note]');
    if (note) note.textContent = etage
      ? 'À partir de 500 € de produits, vous choisissez : bas d’immeuble ou dans la pièce de votre choix. Tarifs France métropolitaine ; Corse et îles : sur devis.'
      : 'Jusqu’à 500 € de produits, la livraison se fait en bas d’immeuble. Tarifs France métropolitaine ; Corse et îles : sur devis.';
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  // Events
  itemsWrap.addEventListener('click', (e) => {
    const row = e.target.closest('[data-em-devis-item]');
    if (!row) return;
    const idx = parseInt(row.dataset.idx, 10);
    const list = load();
    if (e.target.closest('[data-em-minus]')) {
      list[idx].qty = Math.max(1, (list[idx].qty || 1) - 1);
      save(list); render();
    } else if (e.target.closest('[data-em-plus]')) {
      list[idx].qty = (list[idx].qty || 1) + 1;
      save(list); render();
    } else if (e.target.closest('[data-em-remove]')) {
      list.splice(idx, 1);
      save(list); render();
    }
  });
  itemsWrap.addEventListener('change', (e) => {
    if (e.target.matches('[data-em-qty]')) {
      const row = e.target.closest('[data-em-devis-item]');
      const idx = parseInt(row.dataset.idx, 10);
      const list = load();
      list[idx].qty = Math.max(1, parseInt(e.target.value, 10) || 1);
      save(list); render();
    }
  });
  // Sélection du devis → nouvelle wishlist du compte client (2026-10-20).
  // Même fenêtre que « Ajouter le pack à ma wishlist » : connexion, choix ou création de la wishlist.
  if (saveWlBtn) saveWlBtn.addEventListener('click', () => {
    const list = load().filter((it) => it.handle && it.variant_id);
    if (!list.length) return;
    if (!window.EMWishlistERP) { alert('Wishlist momentanément indisponible, réessayez dans un instant.'); return; }
    const first = list.find((it) => it.image);
    const r = window.EMWishlistERP.buildListUrl(
      list.map((it) => ({ handle: it.handle, variant_id: String(it.variant_id), qty: Math.max(1, parseInt(it.qty || 1, 10)) })),
      'Ma sélection devis',
      first ? first.image : ''
    );
    if (!r || !r.count) return;
    // Fenêtre wishlist ouverte sur « Nouvelle wishlist », nom prérempli
    const w = window.EMWishlistERP.openPending();
    const url = r.url + '&nouvelle=1';
    try { if (w && !w.closed) { w.location.href = url; return; } } catch (e) {}
    location.href = url;
  });
  clearBtn.addEventListener('click', () => {
    if (confirm('Vider tout votre devis ?')) {
      save([]);
      render();
    }
  });

  // Adresse de facturation différente : affiche les champs et les rend obligatoires.
  const billingToggle = form.querySelector('[data-em-billing-toggle]');
  const billingBox = form.querySelector('[data-em-billing]');
  if (billingToggle && billingBox) {
    const syncBilling = () => {
      billingBox.hidden = !billingToggle.checked;
      billingBox.querySelectorAll('input').forEach((i) => {
        if (i.name !== 'billing_company') i.required = billingToggle.checked;
      });
    };
    billingToggle.addEventListener('change', syncBilling);
    syncBilling();
  }

  // Livraison dans la pièce : étage + ascenseur affichés et obligatoires (2026-10-07).
  // Champs désactivés quand masqués : ni validés, ni envoyés.
  const accessBox = form.querySelector('[data-em-access]');
  if (accessBox) {
    const syncAccess = () => {
      const piece = (form.querySelector('input[name="shipping"]:checked') || {}).value === 'piece';
      accessBox.classList.toggle('em-devis__access--open', piece);
      accessBox.setAttribute('aria-hidden', piece ? 'false' : 'true');
      accessBox.querySelectorAll('[data-em-access-field]').forEach((f) => {
        f.disabled = !piece;
        f.required = piece;
      });
    };
    form.querySelectorAll('input[name="shipping"]').forEach((r) => r.addEventListener('change', syncAccess));
    syncAccess();
  }

  // Livraison obligatoire : message rouge + défilement si rien n'est choisi (2026-10-07).
  const shipBox = form.querySelector('[data-em-shipping]');
  const shipError = form.querySelector('[data-em-ship-error]');
  const showShipError = () => {
    if (shipError) shipError.hidden = false;
    if (shipBox) {
      shipBox.classList.add('em-devis__shipping--error');
      shipBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  form.querySelectorAll('input[name="shipping"]').forEach((r) => r.addEventListener('change', () => {
    if (shipError) shipError.hidden = true;
    if (shipBox) shipBox.classList.remove('em-devis__shipping--error');
  }));
  // Validation native : on remplace la bulle du navigateur par notre message pour la livraison
  form.addEventListener('invalid', (e) => {
    if (e.target && e.target.name === 'shipping') { e.preventDefault(); showShipError(); }
  }, true);

  // Form submit → POST vers endpoint outils.moood
  const DEVIS_ENDPOINT = 'https://outils.moood.fr/api/em-devis';
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const list = load();
    if (list.length === 0) return;
    // Filet de sécurité si la validation native est contournée
    if (!form.querySelector('input[name="shipping"]:checked')) { showShipError(); return; }
    if (!form.checkValidity()) { form.reportValidity(); return; }
    const fd = new FormData(form);
    const submitBtn = form.querySelector('.em-devis__submit');
    const origLabel = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.innerHTML = 'Envoi en cours…';

    const payload = {
      source: 'easy-mobilier',
      contact: {
        first_name: (fd.get('first_name') || '').trim(),
        last_name: (fd.get('last_name') || '').trim(),
        email: (fd.get('email') || '').trim(),
        phone: (fd.get('phone') || '').trim(),
        company: (fd.get('company') || '').trim(),
        address: (fd.get('address') || '').trim(),
        zip: (fd.get('zip') || '').trim(),
        city: (fd.get('city') || '').trim(),
      },
      billing: fd.get('billing_different') === 'on' ? {
        first_name: (fd.get('billing_first_name') || '').trim(),
        last_name: (fd.get('billing_last_name') || '').trim(),
        company: (fd.get('billing_company') || '').trim(),
        address: (fd.get('billing_address') || '').trim(),
        zip: (fd.get('billing_zip') || '').trim(),
        city: (fd.get('billing_city') || '').trim(),
      } : null,
      shipping: fd.get('shipping'),
      // Prestations facultatives cochées (installation, nettoyage), tableau vide sinon
      prestations: fd.getAll('prestations'),
      // Étage / ascenseur (codes ERP) seulement pour la livraison dans la pièce
      ...(fd.get('shipping') === 'piece' ? {
        etage: Number(fd.get('etage')),
        ascenseur: Number(fd.get('ascenseur')),
      } : {}),
      items: list.map(it => {
        const m = {
          product_id: String(it.product_id || ''),
          variant_id: String(it.variant_id || ''),
          handle: it.handle || '',
          title: it.title || '',
          type: it.type || '',
          unit_price: parseInt(it.unit_price || 0, 10),
          image: it.image || '',
          qty: Math.max(1, parseInt(it.qty || 1, 10)),
        };
        if (it._pack_id) m._pack_id = it._pack_id;
        if (it._pack_name) m._pack_name = it._pack_name;
        return m;
      }),
      note: (fd.get('message') || '').trim(),
      connu_par: (fd.get('connu_par') || '').trim(),
      rgpd: fd.get('rgpd') === 'on' || fd.get('rgpd') === true,
      turnstile_token: (document.querySelector('[name="cf-turnstile-response"]')?.value) || (window.turnstile?.getResponse?.()) || '',
      submitted_at: new Date().toISOString(),
    };

    let resJson = null;
    console.log('[em-devis] Payload envoyé :', payload);
    try {
      const res = await fetch(DEVIS_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      resJson = await res.json().catch(() => ({}));
      console.log('[em-devis] Réponse serveur :', res.status, resJson);
      if (!res.ok || !resJson.ok) {
        const errMsg = resJson?.error || 'Erreur serveur (' + res.status + ')';
        const detailStr = resJson?.details ? '\n\nDétails :\n' + JSON.stringify(resJson.details, null, 2) : '';
        const err = new Error(errMsg);
        err.details = resJson?.details;
        throw err;
      }
    } catch (err) {
      submitBtn.disabled = false;
      submitBtn.innerHTML = origLabel;
      const errBox = document.createElement('div');
      errBox.style.cssText = 'background:#FEE;border:1.5px solid #C00;color:#900;padding:14px 18px;border-radius:10px;margin-top:14px;font-size:13px;';
      const detailsHtml = err.details ? '<br><br><strong>Détails :</strong><br><pre style="background:#FFF;padding:8px;border-radius:6px;font-size:11px;overflow:auto;max-height:200px;margin:4px 0 0;">' + JSON.stringify(err.details, null, 2).replace(/[<>]/g, c => c === '<' ? '&lt;' : '&gt;') + '</pre>' : '';
      errBox.innerHTML = '⚠️ Une erreur est survenue : ' + (err.message || 'inconnue') + detailsHtml + '<br>Réessayez ou contactez-nous directement à <a href="mailto:contact@easy-mobilier.com">contact@easy-mobilier.com</a>.';
      form.appendChild(errBox);
      setTimeout(() => errBox.remove(), 25000);
      return;
    }

    // Succès : vide le devis localStorage + affiche confirmation
    save([]);
    window.dispatchEvent(new Event('storage'));

    const layout = section.querySelector('.em-devis__layout');
    const num = resJson.devis_number || '';
    // Articles retirés car plus en vente (Sébastien 2026-10-12)
    const retires = Array.isArray(resJson.retires) ? resJson.retires : [];
    const esc = (t) => String(t || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const retiresHtml = retires.length ? `
        <div style="text-align:left;background:#FFF7ED;border:1.5px solid #F59E0B;border-radius:10px;padding:12px 14px;margin:14px 0;font-size:14px;color:#7C2D12;">
          <strong>${retires.length} article${retires.length > 1 ? 's ne sont' : ' n’est'} plus disponible${retires.length > 1 ? 's' : ''} et n’${retires.length > 1 ? 'ont' : 'a'} pas été ajouté${retires.length > 1 ? 's' : ''} au devis :</strong>
          <ul style="margin:8px 0 0;padding-left:18px;">${retires.map((r) => `<li>${esc(r.title)}${r.qty > 1 ? ' × ' + r.qty : ''}</li>`).join('')}</ul>
          <p style="margin:8px 0 0;">Notre équipe vous proposera une alternative dans votre devis.</p>
        </div>` : '';
    layout.innerHTML = `
      <div class="em-devis__success" style="grid-column: 1 / -1;">
        <h3>✅ Votre demande de devis a bien été envoyée</h3>
        ${retiresHtml}
        <p>${num ? 'Référence : <strong>' + num + '</strong><br><br>' : ''}Un e-mail de confirmation vient de vous être envoyé. Notre équipe revient vers vous sous <strong>24 h ouvrées</strong> avec votre devis personnalisé.<br><br><a href="/collections/all" style="display:inline-block;margin-top:10px;background:#29594b;color:#FFF;padding:12px 28px;border-radius:999px;text-decoration:none;font-weight:700;">Continuer mes achats →</a></p>
      </div>
    `;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // Initial
  render();
})();
